export const GLOBAL_NAMING = {
  globalConsensusView: {},
  bridgeConsensusView: {},
  syncListView: {
    image: "https://crea.coop/wp-content/uploads/2021/08/map-2021-scaled.jpg",
  },
};
